<template>
    <div class="app_list">
        <div class="title">请选择交易的游戏</div>
        <div class="scrollbar content">
            <div v-for="(item,i) in appList" :key="i" :class="{'app_item':true,'active': gameId == item.id}"
                @click="chooseGame(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)">
                <img class="icon" :src="item.icon" alt="">
                <div class="name">{{ item.app_name }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appList: [],
                role: []
            }
        },
        props: {
            notUserRoleList: Boolean
        },
        computed: {
            gameId() {
                return this.$store.state.gameId
            }
        },
        mounted() {
            this.getAppList()
        },
        methods: {
            getAppList() {
                this.$Ajax('game/app-list').then(rs => {
                    if (rs.code == 200) {
                        this.appList = rs.data
                    }
                })
            },
            chooseGame(name, icon, id,prop_trade,role_trade) {
                this.$store.commit('resetServer')
                this.$store.commit('resetHomeServer')
                this.$store.commit('setGameInfo', {
                    name,
                    icon,
                    id
                })
                
                this.$store.commit('setCt','')
                this.$store.commit('setCi','')
                this.$store.commit('setCt2','')
                this.$store.commit('setCi2','')
                //道具市场 角色市场判断
                this.$store.commit('setHome',{prop_trade,role_trade})
                if(prop_trade == 0) {
                    this.$store.commit('changeHome',2)
                }else {
                    this.$store.commit('changeHome',1)
                }
                //角色市场 筛选全部重置
                this.$store.commit('resetAccPx')

                if (this.$route.name == 'home') {
                    this.$router.replace({
                        name: 'home',
                        query: Object.assign({}, this.$route.query, {
                            id
                        })
                    })
                }

                if(!this.notUserRoleList) {
                    // this.$filterPop({
                    //     type:'server',
                    //     direction: 'up'
                    // })
                    //this.getUserRoleList(id)
                }
                this.$parent.handleClose()
                
            },
            //获取角色列表
            // getUserRoleList(app_id) {
            //     this.$Ajax('user-info/user-role-list', {
            //         app_id
            //     }).then(rs => {
            //         if (rs.code == 200) {
            //             this.role = rs.data
            //         } else {
            //             this.role = []
            //         }
            //         if (this.role.length > 0) {
            //             this.$store.commit('setBindrole', {
            //                 role_id: this.role[0].roleList[0].role_id,
            //                 role_name: this.role[0].roleList[0].role_name,
            //                 server_id: this.role[0].roleList[0].server_id,
            //                 server_name: this.role[0].roleList[0].server_name
            //             })
            //         } else {
            //             this.$store.commit('setBindrole', {
            //                 role_id: '',
            //                 role_name: '',
            //                 server_id: '',
            //                 server_name: ''
            //             })
            //         }
            //     })
            // },
        },
    }
</script>
<style lang="less" scoped>
    .app_list {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .title {
            padding: 0.8rem 1.2rem;
            font-size: 1.6rem;
            height: 3.6rem;
        }

        .content {
            flex: 1;
            padding: 1.2rem;
            padding-right: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-content: flex-start;

            .app_item {
                width: 7.8rem;
                padding: 0.5rem 0;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 2rem;
                border-radius: 0.3rem;
                cursor: pointer;
                border: 1px solid transparent;

                .icon {
                    width: 5rem;
                    height: 5rem;
                    border-radius: 0.8rem;
                    margin-bottom: 0.3rem;
                }

                .name {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    font-size: 1.2rem;
                    text-align: center;
                    transform: scale(0.95);
                    transition: center center;
                }

                &:nth-child(3n+2) {
                    margin: 0 2.5rem 2rem;
                }

                &.active {
                    border-color: var(--theme);
                    background-color: var(--themebgc);

                    .name {
                        color: var(--theme);
                    }
                }

            }
        }
    }
</style>